<template>
<div id="app">
    <div class="alist">
    <div class="item">
        <div class="hangdiv" v-for="(item, index) in dataList" :key="index">
            <div class="title">
                <h1>{{item.storeName}}</h1>
                <span>{{item.luckDrawDate}}</span>
            </div>
            <h2>{{item.name}}&nbsp;&nbsp;&nbsp;获得{{item.prizeLevelStr}}&nbsp;&nbsp;{{item.lottery}}</h2>
        </div>
    </div>
    <div class="alistbottom">
        <img src="/static/images/lotteryListbottom.png" />
    </div>
    </div>
</div>
</template>
<script>
export default {
    name:"app",
    data() {
        return{
            //剩余次数
            number: "",
            //当前页
            pageIndex: 1,
            //总页数
            totalPage: 5,
            dataList: [],
            //是否正在加载数据
            isLoad: false,
            //每页条数
            pageSize: 10
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        //init
        init:function () {
            var that = this;
            document.querySelectorAll("div[class='alist']")[0].addEventListener("scroll",function(){
                //内容的高度
                var middleOuterHeight = this.scrollHeight;
                //可见高度
                var middleHeight = this.offsetHeight;
                //滚动高度
                var scrollTop = this.scrollTop;
                if (scrollTop + middleHeight + 3 > middleOuterHeight) {
                    
                    if (that.isLoad === true || that.pageIndex >= that.totalPage) {
                        return;
                    }
                    if (that.pageIndex < that.totalPage) {
                        that.pageIndex += 1;
                    }
                    that.getData(false);
                }
            });

            this.getData(true);
        },

        //加载数据
        getData:function(isClear){
            var that = this;
            this.isLoad = true;

            var parms={
                page: this.pageIndex,
                rows: this.pageSize
            }
            this.$api.post('/api/lottery/getLuckDogPage',parms,function(res) {
                    that.isLoad = false;
                    if (!res && res.rspCode != "success") {
                        $.alert("获取列表失败，请稍候重试")
                        return;
                    }
                    var item = res.data.records;
                     for (var i = 0; i < item.length; i++) {
                         var date = new Date(item[i].luckDrawDate.replace(/-/g,'/'));
                         item[i].luckDrawDate = (date.getMonth()+1)+"月"+date.getDate()+"日";
                         item[i].prizeLevelStr = item[i].prizeLevel==1?"一等奖":
                                              item[i].prizeLevel==2?"二等奖":
                                              item[i].prizeLevel==3?"三等奖":
                                              item[i].prizeLevel==4?"幸运奖":"";
                         item[i].lottery = item[i].prizeLevel==1?"金猪一个":
                                              item[i].prizeLevel==2?"梦洁乳胶枕一个":
                                              item[i].prizeLevel==3?"康巴赫不粘锅一个":
                                              item[i].prizeLevel==4?"乐扣保温杯一个":"";
                        that.dataList.push(item[i]);
                    }

                    //需要先判断是否能取到count
                    var pagecount = res.data.total || 0;
                    that.getTotalPage(pagecount);

                },
                function(res){
                    that.isLoad = false;
                }
            );

        },
        //获取总页数
        getTotalPage: function(dataLength) {
            var pageNum = 0;
            var _page = parseInt(dataLength / this.pageSize);
            if (_page >= 1) {
                if (dataLength % this.pageSize > 0) {
                    _page += 1;
                }
                pageNum = _page;
            } else {
                pageNum = 1;
            }
            this.totalPage = pageNum;
        },
    }
}
</script>
<style>
body{
    background: #ad1216;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/awardList.vue